<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">
        <span v-if="isCreate">创建项目</span>
        <span v-else>项目</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" outlined small to="/dash/api-debug">API调试</v-btn>
      <v-btn v-if="!isCreate" color="red" class="ml-8" outlined small @click="onDelete">删除</v-btn>
    </v-app-bar>
    <v-container fluid>
      <v-text-field label="名称" hint="网站App名称" class="required" v-model="form.name"></v-text-field>
      <v-text-field label="介绍" v-model="form.description"></v-text-field>
      <v-row dense align="end">
        <v-col cols="6">
          <v-select hide-details label="通知渠道" :items="notifierTypeItems" v-model="form.notifier_type"></v-select>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="5">
          <v-btn outlined color="secondary" :href="DocLink.NOTIFIER" target="_blank">配置教程</v-btn>
        </v-col>
      </v-row>
      <PasswordField
        label="通知地址"
        v-model="form.notifier_url"
        :placeholder="notifierUrlPlaceholder"
        class="mt-4"
      />
      <v-btn color="secondary" v-if="form.notifier_url" @click="onCheckNotifier" class="mb-8">检查通知配置</v-btn>
      <v-text-field v-if="!isCreate && project" label="项目ID" :value="project.id" readonly></v-text-field>
      <PasswordField v-if="!isCreate && project" label="API密钥" readonly :value="project.secret" />
      <v-btn width="100%" color="primary" class="mt-8" @click="onSave">保存</v-btn>
    </v-container>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import PasswordField from '@/components/PasswordField.vue'
import { DocLink } from '@/plugins/doc'
import { NotifierTypeList } from '@/plugins/notifier'
import { homeStore } from '@/store/home'
import { projectStore } from '@/store/project'
import { mdiChevronRight, mdiDelete, mdiPlus } from '@mdi/js'
import _ from 'lodash'

export default {
  name: 'ProjectDetailPage',
  components: { AppbarBackIcon, PasswordField },
  data() {
    let notifierTypeItems = NotifierTypeList.map(item => {
      return { ...item, text: item.name }
    })
    return {
      mdiDelete,
      mdiChevronRight,
      mdiPlus,
      DocLink,
      notifierTypeItems,
      form: {
        name: null,
        description: null,
        notifier_type: null,
        notifier_url: null,
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.id || null
    },
    isCreate() {
      return _.isNil(this.id)
    },
    project() {
      return projectStore.get(this.id)
    },
    notifierUrlPlaceholder() {
      if (!this.form.notifier_type) {
        return ''
      }
      let notifierItem = this.notifierTypeItems.find(item => item.value === this.form.notifier_type)
      if (!notifierItem) {
        return ''
      }
      return notifierItem.placeholder
    },
  },
  async mounted() {
    await homeStore.doLoad()
    if (!_.isNil(this.project)) {
      this.form.name = this.project.name
      this.form.description = this.project.description
      this.form.notifier_type = this.project.notifier_type
      this.form.notifier_url = this.project.notifier_url
    }
  },
  methods: {
    async onSave() {
      if (this.isCreate) {
        let project = await projectStore.doCreate({ ...this.form })
        this.$router.replace({ query: { id: project.id } })
      } else {
        await projectStore.doUpdate({ id: this.id, ...this.form })
      }
      this.$toasted.success('保存成功')
    },
    async onDelete() {
      const msg = `确定要删除项目「${this.project.name}」吗`
      if (!(await this.$dialog.confirm({ text: msg }))) {
        return
      }
      await projectStore.doDelete(this.id)
      this.$toasted.success('删除成功')
      this.$router.back()
    },
    async onCheckNotifier() {
      if (!this.form.notifier_url) {
        return
      }
      const result = await projectStore.doCheckNotifier({
        notifier_type: this.form.notifier_type,
        notifier_url: this.form.notifier_url,
      })
      if (result.is_ok) {
        this.$toasted.success('配置正确，已发送通知测试消息')
        return
      }
      let detail = JSON.stringify(result.detail, null, 2)
      detail = result.message + '\n' + detail
      await this.$dialog.warning({
        title: '配置存在问题',
        text: detail,
        actions: [
          {
            text: '好的',
            color: 'blue',
            key: true,
          },
        ],
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
